import React from "react";
import {
  MdDashboard,
  MdHeadsetMic,
  MdEventSeat,
  MdReceipt,
  MdNotifications,
  MdCollectionsBookmark,
} from "react-icons/md";
import "./Sidebar.css";
import classNames from "classnames";
import { constants } from "../../constants";
import { connect } from "react-redux";

const SidebarMenu = ({ selected, setSelected, setVisible, visible, user }) => {
  return (
    <nav className=" px-4 pb-3 bg-white shadow-xl flex md:flex-col justify-between md:items-center top-0 left-0 sticky z-10 menu">
      <div className="md:flex-1 flex justify-between flex-col">
        <div className="">
          <img
            src={constants.logo}
            alt="logo"
            className="h-16 w-16 object-fill"
          ></img>
        </div>
        <div className="flex md:flex-col space-x-8 md:space-y-6 md:space-x-0 md:items-center">
          <div
            className={classNames({
              // "p-1": true,
              "bg-themeYellow rounded-full": selected === "membership",
            })}
          >
            <button
              onClick={() => setSelected("membership")}
              className="outline-none"
            >
              <MdDashboard size={32} />
            </button>
          </div>
          <div
            className={classNames({
              // "p-1": true,
              "bg-themeYellow rounded-full": selected === "events",
            })}
          >
            <button
              onClick={() => setSelected("events")}
              className="outline-none"
            >
              <MdEventSeat size={32} />
            </button>
          </div>
          <div
            className={classNames({
              // "p-1": true,
              "bg-themeYellow rounded-full": selected === "invoices",
            })}
          >
            <button
              onClick={() => setSelected("invoices")}
              className="outline-none"
            >
              <MdReceipt size={32} />
            </button>
          </div>
          {/* <div
            className={classNames({
              // "p-1": true,
              // "bg-themeYellow rounded-full": selected === "invoices",
            })}
          >
            <button
              // onClick={() => setSelected("invoices")}
              className="outline-none"
            >
              <MdHeadsetMic size={32} />
            </button>
          </div> */}

          {/* Niharika */}
          <div
            className={classNames({
              "p-1": true,
              "bg-themeYellow rounded-full": selected === "bookings",
            })}
          >
            <button
              onClick={() => setSelected("bookings")}
              className="outline-none"
            >
              <MdCollectionsBookmark size={32} />
            </button>
          </div>
          {/* / Niharika / */}
        </div>

      </div>

      <div className="md:flex-1 flex justify-end md:flex-col md:space-y-2 md:space-x-0 space-x-2 md:mt-0 mt-6">
        <div
          className={classNames({
            // "p-1": true,
            "bg-themeYellow rounded-full": selected === "activities",
          })}
        >
          <button
            onClick={() => setSelected("activities")}
            className="outline-none"
          >
            <MdNotifications size={32} />
          </button>
        </div>
        <div
          className={classNames({
            "bg-themeYellow rounded-full": selected === "profile",
          })}
        >
          <button
            onClick={() => setSelected("profile")}
            className="outline-none"
          >
            <img
              src={user?.userProfilePic?.small}
              alt="user_photo"
              className="rounded-full h-8 w-8"
            />
          </button>
        </div>
      </div>
    </nav>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(SidebarMenu);
